/**
 * Nevi Watch — sticky today strip (Executive Glass desk).
 */
import type { ReactNode } from 'react';
import { brand, copy } from '../brand';
import { MobNum } from './MobNum';

export function TodayBoard({
  btc,
  fng,
  passed,
  total,
  running,
  chart,
}: {
  btc: string;
  fng: string | number;
  passed: number;
  total: number;
  running?: boolean;
  chart?: ReactNode;
}) {
  return (
    <section className="tc-mob-today tc-mob-today--eg" aria-label="Nevi Watch">
      <div className="tc-mob-today__glow" aria-hidden />
      <div className="tc-mob-today__head">
        <div className="tc-mob-today__title">
          <span className="tc-mob-today__live" data-on={running ? '1' : '0'} />
          {copy.home.boardTitle}
        </div>
        <div className="tc-mob-today__meta">
          {running ? copy.home.boardRunning : copy.home.boardStandby}
        </div>
      </div>

      {chart && <div className="tc-mob-today__chart">{chart}</div>}

      <div className="tc-mob-today__grid">
        <div className="tc-mob-today__cell">
          <div className="tc-mob-today__label">BTC</div>
          <MobNum size="lg" tone="amber" full={btc}>
            {btc}
          </MobNum>
        </div>
        <div className="tc-mob-today__cell">
          <div className="tc-mob-today__label">F&G</div>
          <MobNum size="lg" tone="cyan">
            {fng}
          </MobNum>
        </div>
        <div className="tc-mob-today__cell">
          <div className="tc-mob-today__label">LAYAK</div>
          <MobNum size="lg" tone="green">
            {passed}
          </MobNum>
        </div>
        <div className="tc-mob-today__cell">
          <div className="tc-mob-today__label">SCAN</div>
          <MobNum size="lg">{total}</MobNum>
        </div>
      </div>

      <div className="tc-mob-today__foot">
        <span className="tc-mob-today__brand">{brand.company}</span>
        <span className="tc-mob-today__ai">{brand.ai}</span>
      </div>
    </section>
  );
}
